import { List, Map } from 'immutable';
import {
  apiKey,
  profileId,
  CLOSE_QUESTIONNAIRE,
  OPEN_QUESTIONNAIRE,
  questionnaireMatchesResults,
  questionnairePrefill,
} from './types';
import InsightProductMatches from 'models/InsightProductMatchesModel';

const basePath = ['marketplace', 'apiKey'];
const profilePath = ['marketplace', 'profileId'];
const prefillPath = ['marketplace', 'questionnairePrefill'];
const matchesResultsDataPath = ['marketplace', 'matchesResultsData'];

const setQuestionnaireMatchesResultsDataRequest = (state, action) =>
  state.withMutations((currentState) => {
    return currentState
      .setIn(
        [...matchesResultsDataPath, 'byId', action.productId.toString(), 'network', 'loading'],
        true,
      )
      .setIn(
        [...matchesResultsDataPath, 'byId', action.productId.toString(), 'network', 'error'],
        false,
      )
      .setIn(
        [...matchesResultsDataPath, 'byId', action.productId.toString(), 'network', 'success'],
        false,
      )
      .setIn([...matchesResultsDataPath, 'byId', action.productId.toString(), 'data'], null);
  });

const setQuestionnaireMatchesResultsDataSuccess = (state, action) =>
  state.withMutations((currentState) => {
    return currentState
      .setIn(
        [...matchesResultsDataPath, 'byId', action.productId.toString(), 'network', 'loading'],
        false,
      )
      .setIn(
        [...matchesResultsDataPath, 'byId', action.productId.toString(), 'network', 'error'],
        false,
      )
      .setIn(
        [...matchesResultsDataPath, 'byId', action.productId.toString(), 'network', 'success'],
        true,
      )
      .setIn(
        [...matchesResultsDataPath, 'byId', action.productId.toString(), 'data'],
        List(action.data?.matches.map(InsightProductMatches.deserialize)),
      );
  });

const setQuestionnaireMatchesResultsDataFailure = (state, action) =>
  state.withMutations((currentState) => {
    return currentState
      .setIn(
        [...matchesResultsDataPath, 'byId', action.productId.toString(), 'network', 'loading'],
        false,
      )
      .setIn(
        [...matchesResultsDataPath, 'byId', action.productId.toString(), 'network', 'error'],
        true,
      )
      .setIn(
        [...matchesResultsDataPath, 'byId', action.productId.toString(), 'network', 'success'],
        false,
      )
      .setIn([...matchesResultsDataPath, 'byId', action.productId.toString(), 'data'], null);
  });

const marketplaceReducerObject = {
  [CLOSE_QUESTIONNAIRE]: (state) =>
    state
      .setIn(['marketplace', 'modal', 'open'], false)
      .setIn(['marketplace', 'modal', 'options'], Map()),
  [OPEN_QUESTIONNAIRE]: (state, action) =>
    state
      .setIn(['marketplace', 'modal', 'open'], true)
      .setIn(['marketplace', 'modal', 'options'], action.options),
  [apiKey.request]: (state) =>
    state
      .setIn([...basePath, 'network', 'error'], false)
      .setIn([...basePath, 'network', 'loading'], true)
      .setIn([...basePath, 'network', 'success'], false)
      .setIn([...basePath, 'data'], null),
  [apiKey.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...basePath, 'network', 'loading'], false)
        .setIn([...basePath, 'network', 'error'], false)
        .setIn([...basePath, 'network', 'success'], true)
        .setIn([...basePath, 'data'], action.response),
    ),
  [apiKey.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...basePath, 'network', 'loading'], false)
        .setIn([...basePath, 'network', 'error'], action.error)
        .setIn([...basePath, 'network', 'success'], false),
    ),
  [profileId.request]: (state) =>
    state
      .setIn([...profilePath, 'network', 'error'], false)
      .setIn([...profilePath, 'network', 'loading'], true)
      .setIn([...profilePath, 'network', 'success'], false)
      .setIn([...profilePath, 'data'], null),
  [profileId.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...profilePath, 'network', 'loading'], false)
        .setIn([...profilePath, 'network', 'error'], false)
        .setIn([...profilePath, 'network', 'success'], true)
        .setIn([...profilePath, 'data'], action.response),
    ),
  [profileId.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn([...profilePath, 'network', 'loading'], false)
        .setIn([...profilePath, 'network', 'error'], action.error)
        .setIn([...profilePath, 'network', 'success'], false),
    ),
  [questionnairePrefill.request]: (state) =>
    state
      .setIn([...prefillPath, 'network', 'error'], false)
      .setIn([...prefillPath, 'network', 'loading'], true)
      .setIn([...prefillPath, 'network', 'success'], false),
  [questionnairePrefill.success]: (state) =>
    state
      .setIn([...prefillPath, 'network', 'error'], false)
      .setIn([...prefillPath, 'network', 'loading'], false)
      .setIn([...prefillPath, 'network', 'success'], true),
  [questionnairePrefill.failure]: (state) =>
    state
      .setIn([...prefillPath, 'network', 'error'], true)
      .setIn([...prefillPath, 'network', 'loading'], false)
      .setIn([...prefillPath, 'network', 'success'], false),
  [questionnaireMatchesResults.request]: setQuestionnaireMatchesResultsDataRequest,
  [questionnaireMatchesResults.success]: setQuestionnaireMatchesResultsDataSuccess,
  [questionnaireMatchesResults.failure]: setQuestionnaireMatchesResultsDataFailure,
};

export default marketplaceReducerObject;
